module.exports = new __parcel__URL__("arrow-right-match.0de9f50b.svg").toString();